export const calculateDaysUntil = (timestampSeconds: number): string => {
  const targetDate = new Date(timestampSeconds * 1000);
  const currentDate = new Date();

  // Set both dates to start of day to get accurate day difference
  targetDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  const timeDifference = targetDate.getTime() - currentDate.getTime();
  const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

  if (daysDifference === 0) {
    return "today";
  } else if (daysDifference === 1) {
    return "1 day";
  } else if (daysDifference > 1) {
    return `${daysDifference} days`;
  } else {
    // Past date
    const pastDays = Math.abs(daysDifference);
    return pastDays === 1 ? "1 day ago" : `${pastDays} days ago`;
  }
};

export const formatCountdownText = (timestampSeconds: number): string => {
  const countdown = calculateDaysUntil(timestampSeconds);
  return countdown === "today"
    ? "Takes place today"
    : `Takes place in ${countdown}`;
};

export const formatDateTime = (
  seconds: number,
  endSeconds?: number,
): string => {
  const date = new Date(seconds * 1000);
  const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "short" });
  const month = date.toLocaleDateString("en-US", { month: "short" });
  const day = date.getDate();
  const time = date.toLocaleTimeString([], { timeStyle: "short" });

  if (endSeconds) {
    const endTime = new Date(endSeconds * 1000).toLocaleTimeString([], {
      timeStyle: "short",
    });
    return `${dayOfWeek}, ${month} ${day} @ ${time} - ${endTime}`;
  }

  return `${dayOfWeek}, ${month} ${day} @ ${time}`;
};
